import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { Users, FileCheck2, FileClock, FileText, TrendingUp } from "lucide-react";
import { reportsSummary as R, filingTrend } from "../mock";

const fmt = (n) => "RM " + Number(n).toLocaleString("en-MY");

const Stat = ({ icon: Icon, label, value, color }) => (
  <div className="bg-white border border-gray-200 rounded-sm shadow-sm p-4 flex items-center gap-4">
    <div className={`w-11 h-11 rounded flex items-center justify-center ${color}`}>
      <Icon size={22} />
    </div>
    <div>
      <div className="text-2xl font-semibold text-gray-800">{value}</div>
      <div className="text-sm text-gray-500">{label}</div>
    </div>
  </div>
);

const Reports = () => {
  return (
    <div className="max-w-[1400px] mx-auto">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-10 h-10 rounded bg-[#1877c9] text-white flex items-center justify-center">
          <TrendingUp size={20} />
        </div>
        <div>
          <h1 className="text-xl font-semibold text-gray-800">Reports & Dashboard</h1>
          <p className="text-sm text-gray-500">Overview of client tax filing performance</p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-5">
        <Stat icon={Users} label="Total Clients" value={R.totalClients} color="bg-blue-100 text-blue-600" />
        <Stat icon={FileCheck2} label="Filed This Year" value={R.filedThisYear} color="bg-green-100 text-green-600" />
        <Stat icon={FileClock} label="Pending Filings" value={R.pendingFilings} color="bg-amber-100 text-amber-600" />
        <Stat icon={FileText} label="Draft Filings" value={R.draftFilings} color="bg-gray-100 text-gray-600" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
        <div className="lg:col-span-2 bg-white border border-gray-200 rounded-sm shadow-sm p-5">
          <h3 className="font-semibold text-gray-800 mb-4">Filing Trend (Filed vs Pending)</h3>
          <div className="h-[320px]">
            <ResponsiveContainer width="100%" height="100%">
              <BarChart data={filingTrend}>
                <CartesianGrid strokeDasharray="3 3" vertical={false} />
                <XAxis dataKey="month" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="filed" name="Filed" fill="#1877c9" barSize={22} radius={[3, 3, 0, 0]} />
                <Bar dataKey="pending" name="Pending" fill="#f0ad4e" barSize={22} radius={[3, 3, 0, 0]} />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>

        <div className="space-y-5">
          <div className="bg-white border border-gray-200 rounded-sm shadow-sm p-5">
            <div className="text-sm text-gray-500">Total Tax Payable (YTD)</div>
            <div className="text-2xl font-bold text-gray-800 mt-1">{fmt(R.totalTaxPayable)}</div>
          </div>
          <div className="bg-white border border-gray-200 rounded-sm shadow-sm p-5">
            <div className="text-sm text-gray-500">Total Tax Refund (YTD)</div>
            <div className="text-2xl font-bold text-green-600 mt-1">{fmt(R.totalTaxRefund)}</div>
          </div>
          <div className="bg-[#6b6b6b] text-white rounded-sm shadow-sm p-5">
            <div className="text-sm opacity-90">Filing Completion</div>
            <div className="text-2xl font-bold mt-1">
              {Math.round((R.filedThisYear / R.totalClients) * 100)}%
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Reports;
